import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AlertModule } from '../alerts/store/alert.module';
import { CoreModule } from '../shared/core.module';
import { LayoutSecureComponent } from './layout-secure/layout-secure.component';
import { LayoutPublicComponent } from './layout-public/layout-public.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderBareComponent } from './header/header-bare/header-bare.component';
import { HeaderFullComponent } from './header/header-full/header-full.component';
import { SsHeaderLogoComponent } from './header/ss-header-logo/ss-header-logo.component';

@NgModule({
    declarations: [
        LayoutSecureComponent,
        LayoutPublicComponent,
        FooterComponent,
        HeaderBareComponent,
        HeaderFullComponent,
        SsHeaderLogoComponent
    ],
    imports: [CommonModule, RouterModule, CoreModule, AlertModule],
    exports: [
        LayoutSecureComponent,
        LayoutPublicComponent,
        HeaderFullComponent,
        FooterComponent,
        HeaderBareComponent
    ]
})
export class LayoutModule {}
